import "bootstrap";

// Set copyright to current year
let year = document.getElementsByClassName("date-year")[0];
year.textContent = new Date().getFullYear();
